export const isActiveOnePassMember = (customer) => {
    const { club, membership } = customer || {};
    return Boolean(club?.active || membership?.subscription?.active);
};
export const isEligibleForOnePassMigration = (customer) => {
    const { membership } = customer || {};
    return membership?.eligibleForMigration ?? false;
};
export const isCancellingMembership = (subscription) => {
    const { active, autoRenewing } = subscription || {};
    return Boolean(active && !autoRenewing);
};
export const isMembershipFreeTrialEligible = (customer) => {
    const { membership } = customer || {};
    const { subscription } = membership || {};
    const { freeTrialEligible } = subscription || {};
    const isLoggedIn = !!customer;
    const isEligible = freeTrialEligible || !membership || !isLoggedIn;
    return isEligible;
};
